export default __webpack_public_path__ + "./images/ci.821a9e6f.png";